import { Controller } from "stimulus"

export default class extends Controller{
  static targets = ["testSelector","testPrice", "discount", "fullPrice", "percent"]
  
  connect(){
    $('.selectpicker').selectpicker();
  }

  refreshValidator(){
    let validator= $(this.element).validate()
    
    if(!validator) return

    // refresh discount validation
    validator.element(`#${this.discountTarget.id}`);
  }

  selectTest(e){
    let optionTestPrice = e.target.selectedOptions[0].dataset.defaultPrice ?? '0.00'

    this.testPriceTarget.value = optionTestPrice 

    if(this.percentCheckedStatus) return

    if(this.hasFullPriceTarget && this.fullPriceTarget.checked){
      this.discountTarget.value = optionTestPrice 
      this.discountTarget.setAttribute('readonly', true)
    }

    this.refreshValidator()
  }

  fullPrice(e){
    this.disableDiscountInput(e.target.checked)

    if(this.percentCheckedStatus){ return }
    
    let selecteOption = this.testSelectorTarget.selectedOptions[0]

    if(e.target.checked && selecteOption.value){
      this.discountTarget.value = parseFloat(selecteOption.dataset.defaultPrice).toFixed(2)
      this.refreshValidator()
    }
  }

  disableDiscountInput(readonly){
    if(readonly)
      this.discountTarget.setAttribute('readonly', readonly)
    else{
      this.discountTarget.removeAttribute('readonly')
    }
  }

  get percentCheckedStatus(){
    return this.hasPercentTarget && this.percentTarget.checked
  }
}